export default __webpack_public_path__ + "static/media/juego27_sinexito2.a64fc9aa.png";